"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTrueUpResultDto = instanceOfTrueUpResultDto;
exports.TrueUpResultDtoFromJSON = TrueUpResultDtoFromJSON;
exports.TrueUpResultDtoFromJSONTyped = TrueUpResultDtoFromJSONTyped;
exports.TrueUpResultDtoToJSON = TrueUpResultDtoToJSON;
exports.TrueUpResultDtoToJSONTyped = TrueUpResultDtoToJSONTyped;
/**
 * Check if a given object implements the TrueUpResultDto interface.
 */
function instanceOfTrueUpResultDto(value) {
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('facilityName' in value) || value['facilityName'] === undefined)
        return false;
    if (!('stripeInvoiceId' in value) || value['stripeInvoiceId'] === undefined)
        return false;
    if (!('error' in value) || value['error'] === undefined)
        return false;
    return true;
}
function TrueUpResultDtoFromJSON(json) {
    return TrueUpResultDtoFromJSONTyped(json, false);
}
function TrueUpResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'facilityId': json['facilityId'],
        'facilityName': json['facilityName'],
        'stripeInvoiceId': json['stripeInvoiceId'],
        'error': json['error'],
    };
}
function TrueUpResultDtoToJSON(json) {
    return TrueUpResultDtoToJSONTyped(json, false);
}
function TrueUpResultDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'facilityId': value['facilityId'],
        'facilityName': value['facilityName'],
        'stripeInvoiceId': value['stripeInvoiceId'],
        'error': value['error'],
    };
}
//# sourceMappingURL=TrueUpResultDto.js.map